import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import db, { realtimeDB } from "./Backend";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import format from "date-fns/format";
import { get, off, onValue, ref, set } from "firebase/database";
import pstpaulemoji from "./images/pstpaul.jpg";
import lindaseng from "./images/lindaseng.png";
import { HbrCancel, HbrCloseIcon, HbrEmoticonIcon, HbrKeypadIcon, HbrLikeEmoji, HbrLoveEmoji, HbrPrayEmoji, HbrSendIcon } from "./MyCustomsvgicons";
import { EmojisActivities, EmojisAnimalsAndNature, EmojisFoodAndDrink, EmojisObjects, EmojisSmileysAndPeople, EmojisSymbols, EmojisTravelAndPlaces, formatNumber, sanitizeText, sendSingleValueDataToDB } from "./utilityClass";
import CustomTextArea from "./newComponent/customTextArea";
import EmojisSheetContent from "./newComponent/emojiContentSheet";


const InputComments = ({programID, openCommentsView, closeCommentsView, roomKey, userName}) => {
  const [showTextarea,setShowTextArea]=useState(false);
  const [wordcount, setWordCount] = useState(false);
  const [isEditable, setIsEditable] = useState(true);
  const [showSendBtn, setShowSendBtn] = useState(false);
  const [emojisArray,setEmojisArray]=useState([]);
  const [likeemojiClked,setLikeClicked]=useState([]);
  const [loveemojiClked,setLoveClicked]=useState([]);
  const [prayemojiClked,setPrayClicked]=useState([]);
  const [rikaEmojiClked,setRikaEmojiClicked]=useState([]);
  const [lindEmojiClked,setLindEmojiClicked]=useState([]);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [message, setMessage]=useState("");
  const [loveCount, setLovecount]=useState(0);
  const [prayCount, setPrayCount]=useState(0);
  const [likesCount, setLikesCount]=useState(0);
  const [rikaEmojiCount, setRikaEmojiCount]=useState(0);
  const [lindaEmojiCount, setLindaEmojiCount]=useState(0);
  const [showEmojis, setShowEmojis] = useState(false);
  const [newComments, setNewComments] = useState(null);
  const [myComment, setMyComment] = useState(false);
//   const {userName} = useContext(DataContext);
  const previousTotalRef = useRef(0);
  const now = new Date();
  const docID = format(now,"yyyyMMddHHmmss");
  const messageTime = format(now, "HH:mm:ss a")
  const timestamp = serverTimestamp();
  

  const handleTypingEvent=useCallback(()=>{
    if (message.trim() !== "") {
      setShowSendBtn(true);
    }else{
      setShowSendBtn(false);
    }
  },[message]);


  useEffect(()=>{
    handleTypingEvent()
  },[handleTypingEvent]);

  const sendComment=async(emoji)=>{
    if (emoji === "" && message === "") {
      return alert ("you are trying to send an empty message");
    }

    if (userName && userName !== "") {
      try {
         await setDoc(doc(db, programID, docID),{
            message,
            user_name: userName,
            emoji: emoji,
            programID: programID,
            // todayComments: date,
            currentTime: messageTime,
            timestamp
         });
         
         setShowTextArea(false);
         if (roomKey) {
            const commentCountRef = `bethelcast-comments${roomKey}`;
            const commentCountsnapshot = await get(ref(realtimeDB, commentCountRef));
            if (commentCountsnapshot.exists()) {
               const newTotal = commentCountsnapshot.val() + 1;
               sendSingleValueDataToDB(commentCountRef, newTotal);
            }else{
               sendSingleValueDataToDB(commentCountRef, 1);
            }
            setMyComment(true);
         }
   
      } catch(error){
         console.log(error);
      }
    }
    setMessage("");
    if (emoji !== "") {
       setShowEmojis(false);
    }
  };

  useEffect(()=>{
   if (roomKey) {
      const commentCountRef = ref(realtimeDB, `bethelcast-comments${roomKey}`);

      const listener = onValue(commentCountRef, (snapshot)=>{
         if (snapshot.exists()) {
            if (myComment) {
               const newTotal = snapshot.val() - 1;
               setNewComments(newTotal - previousTotalRef.current);
            }else{
               const newTotal = snapshot.val();
               setNewComments(newTotal - previousTotalRef.current);
            }
         }
      });
   
      return()=>{
         off(commentCountRef, 'value', listener);
      }
   }
  },[roomKey, myComment]);

  useEffect(()=>{
    async function getEmojis() {
       const emojisSnapshot = await get(ref(realtimeDB, "emojis"));
       if (emojisSnapshot.exists()) {
          const emojisData = emojisSnapshot.val();
          const emojisChildArray = Object.keys(emojisData).map(key => ({
             id: key,
             ...emojisData[key]
          }));
          setEmojisArray([...emojisChildArray, ...EmojisSmileysAndPeople,...EmojisFoodAndDrink, ...EmojisSymbols, ...EmojisTravelAndPlaces, ...EmojisAnimalsAndNature, ...EmojisActivities, ...EmojisObjects]);
       }
    }
    getEmojis();
  },[]);
  const memoizedemojis = useMemo(()=>emojisArray,[emojisArray]);

  const addEmojiToText=(emoji)=>{
    setShowTextArea(true);
    const textBeforeCursor = message.substring(0, cursorPosition);
    const textAfterCursor = message.substring(cursorPosition);
    setMessage(textBeforeCursor + emoji + textAfterCursor);
    setTimeout(() => {
      const textarea = document.getElementById('customtextarea');
      textarea.selectionStart = textarea.selectionEnd = cursorPosition + emoji.length;
    }, 0);
  };

  useEffect(()=>{
    let words = message.split(' ');
     if(words.length >= 500){
         words = words.slice(0, 500);
         setMessage(words.join(' '));
         setWordCount(words.length);
         setIsEditable(false);
     }else{
       setIsEditable(true);
     }
 },[message]);

 const handleKeyDown=(e)=>{
  if(wordcount >= 500 && !isEditable && e.key !== 'Backspace' && e.key !== 'Delete'){
      e.preventDefault(); 
  }
};

const handleTextChange=(e)=>{
  setMessage(e.target.value);
  setCursorPosition(e.target.selectionStart);
};

const handleFocus=(e)=>{
  setCursorPosition(e.target.selectionStart);
};

const closeTextArea=()=>{
   setShowTextArea(false);
   setMessage("");
   if (closeCommentsView) {
      closeCommentsView();
   }
};

const handleKeyPadClicked=async()=>{
   try {
      if (roomKey) {
         const commentCountRef = `bethelcast-comments${roomKey}`;
         const commentCountsnapshot = await get(ref(realtimeDB, commentCountRef));
         if (commentCountsnapshot.exists()) {
            previousTotalRef.current = commentCountsnapshot.val();
         }
      }
      setShowTextArea(true);
      if (openCommentsView) {
         openCommentsView();
      }
      setNewComments(0);
   } catch (error) {
      console.log(error)
   }
};

const handleEmoticonClicked=()=>{
   setShowEmojis(true);
   if (openCommentsView) {
      openCommentsView();
   }
};

const floatingEmojiClicked=async(actionType)=>{
  const likessnapshot = await get(ref(realtimeDB,`live/${programID}/${actionType}`));
     if (likessnapshot.exists()) {
        if (likessnapshot.val() === null || likessnapshot.val() === 0) {
           set(ref(realtimeDB,`live/${programID}/${actionType}`),1);
        }else{
           set(ref(realtimeDB,`live/${programID}/${actionType}`),likessnapshot.val() + 1);
        }
     }else{
        set(ref(realtimeDB,`live/${programID}/${actionType}`),1);
     }
};

useEffect(()=>{
//   const date = format(new Date(), "yyyy-MM-dd");
  const likesRef = ref(realtimeDB,`live/${sanitizeText(programID)}/likeEmoji`);
  const heartRef = ref(realtimeDB,`live/${sanitizeText(programID)}/heartEmoji`);
  const prayRef = ref(realtimeDB,`live/${sanitizeText(programID)}/prayEmoji`);
  const rikaRef = ref(realtimeDB,`live/${sanitizeText(programID)}/rikaEmoji`);
  const lindRef = ref(realtimeDB,`live/${sanitizeText(programID)}/lindaEmoji`);

 const likeListener = onValue(likesRef,(snapshot)=>{
     if (snapshot.exists() && snapshot.val() > 1) {
        setLikesCount(snapshot.val());
     }
  });
 const heartListener = onValue(heartRef,(snapshot)=>{
     if (snapshot.exists() && snapshot.val() > 1) {
        setLovecount(snapshot.val());
     }
  });
 const prayListener = onValue(prayRef,(snapshot)=>{
     if (snapshot.exists() && snapshot.val() > 1) {
        setPrayCount(snapshot.val());
     }
  });
 const rikaListener = onValue(rikaRef,(snapshot)=>{
     if (snapshot.exists() && snapshot.val() > 1) {
        setRikaEmojiCount(snapshot.val());
     }
  });
 const lindaListener = onValue(lindRef,(snapshot)=>{
     if (snapshot.exists() && snapshot.val() > 1) {
        setLindaEmojiCount(snapshot.val());
     }
  });

  return()=>{
     off(likesRef, 'value',likeListener);
     off(heartRef, 'value',heartListener);
     off(prayRef, 'value',prayListener);
     off(rikaRef, 'value',rikaListener);
     off(lindRef, 'value',lindaListener);
  }

},[programID]);

useEffect(()=>{
  setLikeClicked(likeemojiClked => [
     ...likeemojiClked,
     <HbrLikeEmoji width="1.6em" height="1.6em" fillColour="white"/>
  ]);
 
  const timeid = setTimeout(() => {
     setLikeClicked([]);
    
  }, 3000);
  return ()=> clearTimeout(timeid);
},[likesCount]);

useEffect(()=>{
  setLoveClicked(loveemojiClked => [
     ...loveemojiClked,
     <HbrLoveEmoji width={"2em"} height={"2em"} fillColour={"red"}/>
  ]);
 
  const timeid = setTimeout(() => {
     setLoveClicked([]);
  }, 3000);
  return ()=> clearTimeout(timeid);
},[loveCount]);

useEffect(()=>{
  setPrayClicked(prayemojiClked => [
     ...prayemojiClked,
     <HbrPrayEmoji width={"2em"} height={"2em"} fillColour={"#D2691E"}/>
  ]);
  const timeid = setTimeout(() => {
     setPrayClicked([]);
  }, 3000);
  return ()=> clearTimeout(timeid);
},[prayCount]);

useEffect(()=>{
  setRikaEmojiClicked(emojiClked => [
     ...emojiClked,
     <img src={pstpaulemoji} alt="" className="floatingimg" />
  ]);
  const timeid = setTimeout(() => {
     setRikaEmojiClicked([]);
  }, 3000);
  return ()=> clearTimeout(timeid);
},[rikaEmojiCount]);

useEffect(()=>{
  setLindEmojiClicked(emojiClked => [
     ...emojiClked,
     <img src={lindaseng} alt="" className="floatingimg"/>
  ]);
  const timeid = setTimeout(() => {
     setLindEmojiClicked([]);
  }, 3000);
  return ()=> clearTimeout(timeid);
},[lindaEmojiCount]);
   

    return (
        <div className={`input-comments ${roomKey ? 'bethel-cast' : 'radio'} flex-row2`}>
           {showTextarea ?
            (<HbrCancel width="1.7em" height="1.7em" fillColour="#000000" handleClick={()=>closeTextArea()}/>)
            :
            (<HbrEmoticonIcon width="1.7em" height="1.7em" fillColour="white" handleClick={()=>handleEmoticonClicked()}/>)
            }

            {showTextarea && showSendBtn &&
               (<HbrCancel width="2em" height="2em" fillColour="white" handleClick={()=>closeTextArea()}/>)
            }
 
            {showTextarea ?
            (<CustomTextArea 
            value={message} 
            onChange={handleTextChange}
            handleFocus={handleFocus}
            handleClick={handleFocus}
            hint={"write your comment"}
            textareaLineHeight={24}
            maxRows={4}
            handleKeyDown={handleKeyDown}
            />)
            :
            (<div style={{padding:"5px",borderRadius:"50%",backgroundColor:"#10101050", position:"relative"}}>
            <HbrKeypadIcon width="1.5em" height="1.5em" fillColour="white" handleClick={()=>handleKeyPadClicked()}/>
               <h4 style={{color:"white", position:"absolute", top:"0px", right: "0px"}}>
                  {newComments && newComments > 0 ? newComments : ""}
               </h4>
            </div>
            )
            }

            {showTextarea && showSendBtn &&
               (<HbrSendIcon width="2em" height="2em" fillColour="white" handleClick={()=>sendComment("")}/>)
            }

            {!showTextarea && (
            <div className="floatingemojis flex-row2" style={{borderRadius:"10px",padding:"5px",marginRight:"1.2em"}}>

                  <div className="flex-column2" style={{padding:"2px",position:"relative",caretColor:"transparent",cursor:"pointer"}}
                     onClick={()=>floatingEmojiClicked("heartEmoji")}>
                     
                           <div className="floatingemoji"> 
                              {loveemojiClked && loveemojiClked.map((Emoji,index)=>(
                              <div className="emojitofloat" key={index}>
                                 <div>{Emoji}</div>
                              </div>
                              ))}
                           </div>  
                     
                              <p id="countreactiontext" style={{fontWeight:"bold"}}>{formatNumber(loveCount)}</p>
                           <div style={{borderRadius:"50%",backgroundColor:"white"}} >
                              <HbrLoveEmoji width="2em" height="2em" fillColour="red"/>
                           </div>
                  </div>

                  <div className="flex-column2" style={{padding:"2px",position:"relative",caretColor:"transparent"}} onClick={()=>floatingEmojiClicked("likeEmoji")}>

                     <div className="floatingemoji"> 
                        {likeemojiClked && likeemojiClked.map((Emoji,index)=>(
                           <div className="emojitofloat" key={index}>
                              <div className="likefloatingemoji">{Emoji}</div>
                           </div>
                        ))}
                     </div>  
                  
                     <p id="countreactiontext" style={{fontWeight:"bold"}}>{formatNumber(likesCount)}</p>
                     <div style={{borderRadius:"50%", backgroundColor:"green", padding:"4px"}}>
                     <HbrLikeEmoji width="1.6em" height="1.6em" fillColour="white"/>
                     </div>
                     
                  </div>

                  <div className="flex-column2" style={{position:"relative",caretColor:"transparent",cursor:"pointer"}} onClick={()=>floatingEmojiClicked("prayEmoji")}>

                     <div className="floatingemoji"> 
                        {prayemojiClked && prayemojiClked.map((Emoji,index)=>(
                           <div className="emojitofloat" key={index}>
                              <div>{Emoji}</div>
                           </div>
                        ))}
                     </div>  
                  
                     <p id="countreactiontext" style={{fontWeight:"bold"}}>{formatNumber(prayCount)}</p>
                     <HbrPrayEmoji width="2em" height="2em" fillColour="#D2691E"/>
                  </div>

                  <div className="flex-column2" style={{position:"relative",caretColor:"transparent",cursor:"pointer"}} onClick={()=>floatingEmojiClicked("rikaEmoji")}>
                        <div className="floatingemoji"> 
                           {rikaEmojiClked && rikaEmojiClked.map((Emoji,index)=>(
                              <div className="emojitofloat" key={index}>
                                 <div>{Emoji}</div>
                              </div>
                           ))}
                        </div>  
                  
                        <p id="countreactiontext" style={{fontWeight:"bold"}}>{formatNumber(rikaEmojiCount)}</p>
                        <img src={pstpaulemoji} alt="" className="floatingimg" onSelect={(e)=>e.preventDefault()}/>
                  </div>

                  <div className="flex-column2" style={{position:"relative",caretColor:"transparent",cursor:"pointer"}} onClick={()=>floatingEmojiClicked("lindaEmoji")} >
                        <div className="floatingemoji" style={{right:"3em"}}> 
                           {lindEmojiClked && lindEmojiClked.map((Emoji,index)=>(
                              <div className="emojitofloat" key={index}>
                                 <div>{Emoji}</div>
                              </div>
                           ))}
                        </div>  
                  
                        <p id="countreactiontext" style={{fontWeight:"bold"}}>{formatNumber(lindaEmojiCount)}</p>
                        <img src={lindaseng} alt="" className="floatingimg" onSelect={(e)=>e.preventDefault()}/>
                  </div>

            </div>)
            }

            {showEmojis && (
               <div className="emojissheetlayout flex-column1">
                     <div className="emojissheetlayouttop flex-spacebetween" style={{
                           width:"100%",
                           height:"10%",
                           paddingLeft:"5px",
                           paddingRight:"5px",
                           paddingTop:"5px",
                           paddingBottom:"5px",
                           borderBottom:"5px solid #333333",
                           borderTopLeftRadius:"10%",
                           borderTopRightRadius:"10%",
                           boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)"
                           }}>
                        <h4 style={{color:"white",fontWeight:"bold"}}>Add Reactions</h4>                       
                         <HbrCloseIcon width="2em" height="2em" fillColour="white" handleClick={()=>setShowEmojis(false)}/>
                     </div>

                     <div className="emojicontentholder flex-row2" style={{gap:"10px",width:"100%",height:"90%",flexWrap:"wrap",overflow:"auto"}}>
                     {memoizedemojis && memoizedemojis.map((data, index) =>(
                           <EmojisSheetContent
                           key={index}
                           url={data.url && data.url}
                           emoji={data.emoji && data.emoji}
                           imageClicked={sendComment}
                           emojiClicked={addEmojiToText}
                        />
                     ))}
                     </div>
               </div>
              )
            }
            
          {/* {
            hideInputs &&
            <div className="hide-inputs">
                <h3>The host has disabled comments for this session</h3>
            </div>
          } */}
     
        </div>
      );
}
export default InputComments;